
export enum BranchType {
  FRANCHISE= 'franchise',
  OWN = 'own',
  CERTIFIED = 'certified',
  AGGREGATION_NETWORK = 'aggregation_network',
}

export const BRANCH_TYPES_ORDER: BranchType[] = [
  BranchType.OWN,
  BranchType.FRANCHISE,
  BranchType.CERTIFIED,
  BranchType.AGGREGATION_NETWORK,
];

export const sortBranchTypes = (branchTypes: BranchType[]): BranchType[] => {
  const orderOf = (branchType: BranchType) => {
    const index = BRANCH_TYPES_ORDER.indexOf(branchType);
    return index === -1 ? BRANCH_TYPES_ORDER.length : index;
  };
  return [...branchTypes].sort((a, b) => orderOf(a) - orderOf(b));
};
